import { createApp } from 'vue'
import App from './App.vue'
// JS SDK init 카카오 공유하기 기능
const KAKAKO_API_KEY = '690cdd3391de80febcac6d7950069813';
window.Kakao.init(KAKAKO_API_KEY);

createApp(App).mount('#app')
